/**
 * Hook for checking if a variable is synced from Grab
 */
import { ALL_TENANT_CONFIGS, GRAB_TENANT_SEQ } from '../config';
import { VariableInfo } from '@/lib/PlannerDTOs';

/**
 * Returns true if the variable is synced from Grab (sourceTenantSeq === 1)
 * Only returns true when on a tenant portal, as "synced from Grab" only makes sense from a tenant's perspective
 * Used to determine if metadata editing should be locked on a tenant portal
 */
export function useIsSyncedFromGrab(
  variable: VariableInfo | null | undefined,
): boolean {
  if (!variable) return false;
  return (
    ALL_TENANT_CONFIGS.some((c) => c.isCurrentTenant()) &&
    variable.sourceTenantSeq === GRAB_TENANT_SEQ
  );
}
